import { render, staticRenderFns } from "./PorAcs.vue?vue&type=template&id=6b31cb74&scoped=true"
import script from "./PorAcs.vue?vue&type=script&lang=js"
export * from "./PorAcs.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=6b31cb74&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b31cb74",
  null
  
)

export default component.exports